/** Stable-partitions items into three groups, preserving relative order within
 *  each: positive quantity (already ordered / in cart) first, then the rest, then
 *  the deprioritized — a dish carrying an allergen we couldn't substitute away,
 *  which belongs after the meals they can actually order. Something already in
 *  the plan stays put even if flagged; that was the customer's own choice.
 *  Shared between MealPlanViewer's order list and MenuPage's dish sections. */
export function sortQuantityFirst(
  items,
  getQuantity = (item) => item.quantity,
  isDeprioritized = () => false,
) {
  const ordered = items.filter((item) => getQuantity(item) > 0);
  const rest = items.filter((item) => getQuantity(item) <= 0);
  return [
    ...ordered,
    ...rest.filter((item) => !isDeprioritized(item)),
    ...rest.filter((item) => isDeprioritized(item)),
  ];
}
